import { ref } from 'vue'
import axios from 'axios'
import { log } from "@/composables/useLog"
import { BASE_URL } from "@/composables/url_config"

const error = ref(null)

export const sendUsernameReminder = async (email) => {
    log("sendUsernameReminder called with email: " + email)
    error.value = null
    try {
        const result = await axios.post(`${BASE_URL}/home/sendUsernameReminder`, {
            email: email
        }, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        })
        error.value = null
        log("sendUsernameReminder result:")
        log(result.data)
        if (typeof result.data === 'string') {
            return JSON.parse(result.data)
        }
        return result.data
    } catch (err) {
        log("Error in sendUsernameReminder:")
        log(err)
        error.value = "Eroare la trimiterea reminder-ului"
        return { error: true, message: "Eroare la trimiterea reminder-ului" }
    }
}

const useSendUsernameReminder = () => {
    return { error, sendUsernameReminder }
}
export default useSendUsernameReminder
